import { createFileRoute, Link } from "@tanstack/react-router";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

import { useT } from "@/lib/i18n";

export const Route = createFileRoute("/platba/zruseno")({
  ssr: false,
  component: PaymentCancelPage,
  head: () => ({
    meta: [
      { title: "Platba zrušena — Cerveza.International" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});

function PaymentCancelPage() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-background">

      <div className="mx-auto max-w-xl px-4 py-16 text-center">
        <XCircle className="mx-auto mb-4 h-16 w-16 text-muted-foreground" />
        <h1 className="font-serif text-3xl">{t("pay.cancelTitle")}</h1>
        <p className="mt-3 text-muted-foreground">{t("pay.cancelDesc")}</p>
        <Button asChild className="mt-6">
          <Link to="/moje-podniky">{t("pay.backToMy")}</Link>
        </Button>
      </div>
    </div>
  );
}
